












































import { FilterData } from "@/domain/types/transactions_query";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types";

@Component
export default class BetterHeaderFilter extends Vue {
  @Prop({ required: true }) header!: DataTableHeader;
  @Prop({ required: false }) filter!: FilterData;
  @Prop({ required: false }) value!: string | string[];

  searchText = "";
  selectedValues: string[] = [];

  mounted() {
    this.refreshValue();
  }

  refreshValue() {
    if (this.filter.tSearch && typeof this.filter.value === "string") {
      if (this.searchText !== this.filter.value) {
        this.searchText = this.filter.value as string;
      }
    }
    if (this.filter.tList && Array.isArray(this.filter.value)) {
      if (this.selectedValues !== this.filter.value) {
        this.selectedValues = this.filter.value as string[];
      }
    }
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  @Watch("searchText")
  onSearch(value: string) {
    this.$emit("input", value);
  }

  @Watch("selectedValues")
  onSelected(value: string[]) {
    this.$emit("input", value);
  }

  @Watch("value")
  onFilter() {
    this.refreshValue();
  }

  selectAllIcon(): string {
    const filter = this.filter;
    if (this.selectedValues.length === filter.tList?.options?.length) return "mdi-close-box";
    if (this.selectedValues.length > 0) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  selectAllIconCss(): string {
    return this.selectedValues.length > 0 ? "indigo darken-4" : "";
  }

  selectAllToggle(force?: boolean) {
    const filter = this.filter;
    if (!filter.tList) return;
    if (!force && this.selectedValues.length === filter.tList?.options?.length) {
      this.onSelected([]);
    } else {
      this.onSelected([...(filter.tList?.options || []).map((t) => t.value)]);
    }
  }

  selectedFilterLabels(): string {
    const filter = this.filter;
    return this.selectedValues.map((v) => filter.tList?.options?.find((o) => o.value === v)?.text || v).join(", ");
  }
}
